@if (model) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <thirdparty-linkable
            #linkable
            data-uiid="auditthirdparty-linkable"
            typename="Thirdparty"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            (linkedChange)="linkedChanged($event)"
            [disabled]="disabled"
        >
        </thirdparty-linkable>
    }
}
